import { AnyAction } from 'redux';
import { AspectRatiosEnum } from '../../components/SubSections/Topic/imageComponents/editImage';
import {
	SET_NEW_STANDARD_CROP,
	SET_NEW_STANDARD_CROPPED_IMAGE_PREVIEW,
	SET_OLD_STANDARD_CROP,
	SET_OLD_STANDARD_CROPPED_IMAGE_PREVIEW,
	SET_PORTRAIT_CROP,
	SET_PORTRAIT_CROPPED_IMAGE_PREVIEW,
	SET_SELECTED_CROP_AR_TYPE,
	SET_STANDARD_CROP,
	SET_STANDARD_CROPPED_IMAGE_PREVIEW,
	SET_WIDE_CROP,
	SET_WIDE_CROPPED_IMAGE_PREVIEW,
	SET_SELECTED_IMG_REF
} from '../types/crop-types';
import { Crop } from 'react-image-crop';

type initialStateType = {
	selectedCropARType?: AspectRatiosEnum;

	oldStandardCrop?: Crop;
	newStandardCrop?: Crop;
	standardCrop?: Crop;
	wideCrop?: Crop;
	portraitCrop?: Crop;

	standardCroppedImagePreview?: HTMLImageElement;
	oldStandardCroppedImagePreview?: HTMLImageElement;
	newStandardCroppedImagePreview?: HTMLImageElement;
	portraitCroppedImagePreview?: HTMLImageElement;
	wideCroppedImagePreview?: HTMLImageElement;
	seletedImgRef?: React.RefObject<HTMLImageElement>;
};

const initialState: initialStateType = {
	selectedCropARType: AspectRatiosEnum.STANDARD,

	oldStandardCrop: undefined,
	newStandardCrop: undefined,
	standardCrop: undefined,
	wideCrop: undefined,
	portraitCrop: undefined,

	standardCroppedImagePreview: new Image(),
	oldStandardCroppedImagePreview: new Image(),
	newStandardCroppedImagePreview: new Image(),
	portraitCroppedImagePreview: new Image(),
	wideCroppedImagePreview: new Image(),
	seletedImgRef: undefined
};

export default function cropReducer(state = initialState, action: AnyAction) {
	switch (action.type) {
		case SET_SELECTED_CROP_AR_TYPE:
			console.log('AR type', action.payload);
			return {
				...state,
				selectedCropARType: action.payload
			};
		case SET_STANDARD_CROP:
			return {
				...state,
				standardCrop: action.payload
			};
		case SET_NEW_STANDARD_CROP:
			return {
				...state,
				newStandardCrop: action.payload
			};
		case SET_OLD_STANDARD_CROP:
			return {
				...state,
				oldStandardCrop: action.payload
			};
		case SET_PORTRAIT_CROP:
			return {
				...state,
				portraitCrop: action.payload
			};
		case SET_WIDE_CROP:
			return {
				...state,
				wideCrop: action.payload
			};

		case SET_STANDARD_CROPPED_IMAGE_PREVIEW:
			return {
				...state,
				standardCroppedImagePreview: action.payload
			};

		case SET_OLD_STANDARD_CROPPED_IMAGE_PREVIEW:
			return {
				...state,
				oldStandardCroppedImagePreview: action.payload
			};

		case SET_NEW_STANDARD_CROPPED_IMAGE_PREVIEW:
			return {
				...state,
				newStandardCroppedImagePreview: action.payload
			};

		case SET_PORTRAIT_CROPPED_IMAGE_PREVIEW:
			return {
				...state,
				portraitCroppedImagePreview: action.payload
			};

		case SET_WIDE_CROPPED_IMAGE_PREVIEW:
			return {
				...state,
				wideCroppedImagePreview: action.payload
			};
		case SET_SELECTED_IMG_REF:
			return {
				...state,
				seletedImgRef: action.payload
			};
		default:
			return state;
	}
}
